import { render, staticRenderFns } from "./BaseImage.html?vue&type=template&id=36d3b250&"
import script from "./BaseImage.js?vue&type=script&lang=js&"
export * from "./BaseImage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports